import React, { useState } from "react";
import Footer from "components/global/footer";
import HeroBanner from "components/herobanner";
import MapComponent from "components/mapcomponent";
import { Helmet } from "react-helmet";
import { collection, addDoc } from 'firebase/firestore';
import { db } from "firebase-config";


const contactInformation = [
  {
    id: 0,
    text: "+91 9920277081",
    link: "tel:+919920277081",
    icon: (
      <svg
        width="33"
        height="34"
        viewBox="0 0 33 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* SVG Path */}
      </svg>
    ),
  },
  {
    id: 1,
    text: "admin@surpeats.com",
    link: "mailto:admin@surpeats.com",
    icon: (
      <svg
        width="33"
        height="34"
        viewBox="0 0 33 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* SVG Path */}
      </svg>
    ),
  }
];

export default function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "ContactFormUser"), formData);
      alert("Message sent successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message: ", error);
      alert("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact us</title>
      </Helmet>
      <HeroBanner
        showAppLogoInHeader={false}
        sectionClassName="relative pt-40 pb-28 lg:py-56"
        heroBannerImgUrl="images/contact-us-banner.png"
        title={`Contact us`}
        titleClassName="mb-0 lg:text-5xl"
        titleWrapperClassName="absolute left-6 top- lg:left-24 lg:bottom-12 max-w-max"
      />
      <section className="py-10 lg:py-32">
        <div className="container">
          <div className="flex gap-6 flex-col lg:gap-32 lg:flex-row">
            <div className="max-w-96 w-full">
              <h2 className="text-4xl text-black-100 mb-4 lg:text-5xl font-anton">
                Contact information
              </h2>
              <p className="text-gray-100">
                Fill up the form and our team will get back to you within 24
                hours.
              </p>
              <ul className="mt-6 space-y-4">
                {contactInformation.map((item, index) => (
                  <li
                    key={`contact-information-${index}`}
                    className="flex items-center gap-1"
                  >
                    {item.icon}
                    {item?.link ? (
                      <a
                        href={item?.link}
                        className="text-sm font-semibold text-black-100"
                      >
                        {item?.text}
                      </a>
                    ) : (
                      <span className="text-sm font-semibold text-black-100">
                        {item.text}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1">
              <form className="space-y-8" onSubmit={handleSubmit}>
                <div className="space-y-6">
                  <div>
                    <label htmlFor="firstName" className="input-label">
                      First name
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      placeholder="Insert your first name"
                      className="input"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="lastName" className="input-label">
                      Last name
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      placeholder="Insert your last name"
                      className="input"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="input-label">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Insert your email"
                      className="input"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="phoneNumber" className="input-label">
                      Phone number
                    </label>
                    <input
                      type="number"
                      name="phoneNumber"
                      id="phoneNumber"
                      placeholder="Insert your phone number"
                      className="input"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="input-label">
                      Message the host (Optional)
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Type here..."
                      className="input resize-none"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <button
                  className="px-14 py-4 bg-primary-200 rounded-lg text-base font-bold text-white"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <MapComponent />
      <Footer />
    </>
  );
}
